import { Modal } from 'antd'
import Flex from 'components/Flex'
import Button from '../Button'
import React from 'react'
import { ShortlistDiv, TextDescription, UploadMsgFlex } from './style'

const CloseRoleDrawer = ({
  description,
  Textdescription,
  Icon,
  showDrawer,
  setShowDrawer,
  onCloseClick,
  loading,
  closeText = 'No',
  YesText = 'Yes',
  showYes = true,
  percentHeight = '28px',
  percentWeight = '451px',
  closeButtonHeight = '38px', // New prop for close button height
  closeButtonWidth = '64px', // New prop for close button width
  yesButtonHeight = '38px', // New prop for Yes button height
  yesButtonWidth = '64px', // New prop for Yes button width
  onApprove,
  zIndex,
  setButtonLoading = () => {},
}) => {
  const onClose = () => {
    setShowDrawer(false)
    setButtonLoading(false)
    onCloseClick()
  }

  return (
    <div>
      <Modal
        open={showDrawer}
        centered
        footer={''}
        maskClosable={false}
        closable={false}
        zIndex={10000}
        width={828}
        bodyStyle={{
          borderRadius: '15px',
          width: '828px',
          height: '434px',
          padding: '32px 24px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: 1,
        }}
      >
        <UploadMsgFlex
          column
          center
          centerVertically
          style={{ alignItems: 'center', textAlign: 'center' }}
        >
          <Icon></Icon>
          <ShortlistDiv
            percentHeight={'max-height'}
            percentWeight={percentWeight}
            style={{ textAlign: 'center', width: '100%' }}
          >
            {description}
          </ShortlistDiv>
          {Textdescription && (
            <TextDescription> {Textdescription}</TextDescription>
          )}

          <Flex style={{ gap: '1em', justifyContent: 'center' }}>
            <Button.Secondary
              text={closeText}
              width={closeButtonWidth} // Dynamic width for close button
              height={closeButtonHeight} // Dynamic height for close button
              onClick={onClose}
            />
            {showYes && (
              <Button.Primary
                text={YesText}
                width={yesButtonWidth}
                height={yesButtonHeight}
                onClick={() => {
                  if (onApprove) {
                    onApprove()
                  }
                  if (onCloseClick) {
                    onCloseClick()
                  }
                  setShowDrawer(false)
                }}
              />
            )}
          </Flex>
        </UploadMsgFlex>
      </Modal>
    </div>
  )
}

export default CloseRoleDrawer
